/*
 * @Author: van
 * @Date: 2021-08-16 14:07:44
 * @LastEditors: van
 * @LastEditTime: 2021-09-30 09:54:42
 */
//公共
export const COM_LOADING = 'COM_LOADING';

export const CARTNUM = 'CARTNUM';

export const STAFF_LIST = 'STAFF_LIST';
export const MSG_LIST = 'MSG_LIST';
export const ROLE_LIST = 'ROLE_LIST';

export const SYSTEM_TIME = 'SYSTEM_TIME';
export const SYSTEM_DATE = 'SYSTEM_DATE';

export const STATUS_LIST = 'STATUS_LIST'; //状态列表
export const EDUCATION_LIST = 'EDUCATION_LIST'; //状态列表
export const CHOOSEGOODS_LIST = "CHOOSEGOODS_LIST"; //物品选择列表
export const GOODSSELECTED_LIST = "GOODSSELECTED_LIST"; //商品选中列表
// 登录
export const LOG_GETUSERINFO = 'LOG_GETUSERINFO';

//首页
export const INDEX_COLLAPSE = 'INDEX_COLLAPSE';

//菜单相关信息
export const MENU_ID = 'MENU_ID';
export const MENU_AUTH = 'MENU_AUTH';

// 订单Drawer 显示隐藏Visible
export const INDEX_ORDERDRAWERVISIBLE = 'INDEX_ORDERDRAWERVISIBLE';

// 网址URL 绝对路径
export const WWWURL = 'WWWURL'

// tinymce key计数
export const TINYMCEFLAG = 'TINYMCEFLAG'

// 面包屑
export const MENUBREAD = 'MENUBREAD'

// 分类大菜单 是否显示
export const ISMENUDRAWER = 'ISMENUDRAWER'

// tags显示隐藏
export const IS_INFOTAGS = 'IS_INFOTAGS'
//table loading
export const TABLELOADING = 'TABLELOADING'
